angular.module("app").directive("sportPopularColorCombination", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbSportPopularColorCombination/dbSportPopularColorCombinationView.html",
    link: link,
    scope: {
      selectedColor: "=",
      data: "="
    }
  };
});
